import { compose, mapProps, withProps } from 'recompose';
import { withRouter } from 'react-router';
import { get } from 'lodash';

import * as storage from '@inqool/uas-web-core/es/utils/storage';

const withAdditionalProps = compose(
  withRouter,
  withProps(() => {
    try {
      const permissions: Array<string> = JSON.parse(storage.get('permissions'));
      const showDeleted = permissions.find(p => p === 'ROLE_DELETED_VIEW') ? true : undefined;
      return { showDeleted };
    } catch (e) {
      return;
    }
  }),
  mapProps(({ universalFilter, history, gridProps, showDeleted, ...rest }) => ({
    history,
    gridProps: {
      ...gridProps,
      showDeleted,
      universalFilter: universalFilter ? universalFilter : get(history, 'location.state.universalFilter', ''),
      enableUniversalFilter: true,
      doPost: true,
      filtering: true,
      changeFilterValueOnEnter: true,
      changeUniversalFilterValueOnEnter: true,
      pageSizeItems: [
        { id: 10, label: '10' },
        { id: 20, label: '20' },
        { id: 50, label: '50' },
        { id: 100, label: '100' },
        { id: 200, label: '200' }
      ]
    },
    ...rest
  }))
);

export default withAdditionalProps;



// WEBPACK FOOTER //
// ./src/components/hoc/withAdditionalProps/withAdditionalProps.ts